import { createSlice } from "@reduxjs/toolkit";
import { projectDelete } from "./projectAsyncThunk";

const projectDeleteSlice = createSlice({
  name: "project",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [projectDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [projectDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [projectDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default projectDeleteSlice.reducer;
